import { render } from "./CompMsg.vue?vue&type=template&id=6af2a420&scoped=true"
import script from "./CompMsg.vue?vue&type=script&lang=js"
export * from "./CompMsg.vue?vue&type=script&lang=js"

import "./CompMsg.vue?vue&type=style&index=0&id=6af2a420&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af2a420"]])

export default __exports__